import Swiper from 'swiper'
import { EffectFade, Autoplay, Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/effect-fade'
// import 'swiper/css/navigation'

/**
 * SWIPER モジュール（v12）
 * - .js-swiper-hero 内の .swiper をフェードエフェクト付きで自動スライド
 */
export const SWIPER = {
  init() {
    const heroContainer = document.querySelector('.js-swiper-hero')
    if (heroContainer) {
      /* eslint-disable no-unused-vars */
      const heroSwiper = new Swiper(heroContainer.querySelector('.swiper'), {
        modules: [EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        followFinger: false,
      })
      /* eslint-enable no-unused-vars */
    }

    const worksContainer = document.querySelector('.js-swiper-works')
    if (worksContainer) {
      /* eslint-disable no-unused-vars */
      const swiper = new Swiper(worksContainer.querySelector('.swiper'), {
        modules: [EffectFade, Navigation],
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        navigation: {
          nextEl: worksContainer.querySelector('.swiper-button-next'),
          prevEl: worksContainer.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          769: {
            spaceBetween: 60,
          },
        },
      })
      /* eslint-enable no-unused-vars */
    }
  },
}
